import React from "react";

import Sidebar from "components/sidebar/Sidebar.js";

import { Box, Portal, useDisclosure } from "@chakra-ui/react";
import { useState, useEffect } from "react";

import Navbar from "components/navbar/NavbarAdmin.js";
import axios from "axios";
import { SidebarContext } from "contexts/SidebarContext";

import { fetchList } from "api/function";
import routes from "routes.js";

import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import main_logo from "assets/auto_sights.svg";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import ChatInterface from "components/chat/chatInterface";
import {
  Button,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import logoWhite from "assets/img/layout/logoWhite.png";
import { Loader2 } from "components/Loader";
import ChatInterfaceDocuments from "components/chat/chatInterfaceDocuments";
const api_url = process.env.REACT_APP_API;

export default function ChatBotPage(props) {
  const { onOpen } = useDisclosure();

  const [chatType, setTypeChat] = useState(null);

  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const [data, setData] = useState([]);
  const [datasets, setDatasets] = useState([]);

  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  // const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    if (chatType === "database_chat") {
      setLoading(true);
      fetchList("", `${api_url}/bigquery/datasets/data_set_medi_doc_1/tables`)
        .then((response) => {
          setTables(response.tables);
          setLoading(false);
        })
        .catch((error) => {
          alert(error);
        });
    } else if (chatType === "document_chat") {
    }
  }, [chatType]);

  const borderColor = useColorModeValue("white", "navy.800");

  return (
    <Box>
      <Box>
        <SidebarContext.Provider>
          <Sidebar />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: "100%", xl: "calc( 100% - 290px )" }}
            maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={"Horizon UI Dashboard PRO"}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={false}
                  // handleDownloadFileClick={handleDownloadFileClick}
                  // handleBigQueryClick={handleBigQueryClick}
                  // {...rest}
                />
              </Box>
            </Portal>
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                <>
                  {loading ? (
                    <Loader2 />
                  ) : (
                    <Box
                      height="80vh"
                      width="100%"
                      display="flex"
                      flexDirection="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {chatType ? (
                        <>
                          {chatType === "database_chat" ? (
                            <ChatInterface
                              tables={tables}
                              selectedTable={selectedTable}
                              setSelectedTable={setSelectedTable}
                            ></ChatInterface>
                          ) : chatType === "document_chat" ? (
                            <ChatInterfaceDocuments />
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          <Flex
                            width="25%"
                            justify="center"
                            direction="column"
                            align="center"
                            bg="white"
                            borderRadius="30px"
                            position="relative"
                            mr="30px"
                          >
                            <Flex
                              border="5px solid"
                              borderColor={borderColor}
                              bg="linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"
                              borderRadius="50%"
                              w="94px"
                              h="94px"
                              align="center"
                              justify="center"
                              mx="auto"
                              position="absolute"
                              left="50%"
                              top="-47px"
                              transform="translate(-50%, 0%)"
                            >
                              <Image src={main_logo} w="40px" h="40px" />
                            </Flex>
                            <Flex
                              direction="column"
                              mb="12px"
                              align="center"
                              justify="center"
                              px="15px"
                              pt="55px"
                            >
                              <Text
                                fontSize={{ base: "lg", xl: "18px" }}
                                color="black"
                                fontWeight="bold"
                                lineHeight="150%"
                                textAlign="center"
                                px="10px"
                                mt="10px"
                                mb="6px"
                              >
                                Chat with your documents.
                              </Text>
                              <Text
                                fontSize="14px"
                                color={"black"}
                                fontWeight="500"
                                px="10px"
                                mb="6px"
                                textAlign="center"
                              >
                                Chat with your documents.
                              </Text>
                            </Flex>
                            <Button
                              onClick={() => {
                                setTypeChat("document_chat");
                              }}
                              bg="gray.200"
                              _hover={{ bg: "#422AFB", color: "white" }}
                              _active={{ bg: "whiteAlpha.100" }}
                              mb={{ sm: "16px", xl: "24px" }}
                              color={"black"}
                              fontWeight="regular"
                              fontSize="sm"
                              minW="185px"
                              mx="auto"
                            >
                              Chat
                            </Button>
                          </Flex>
                          <Flex
                            width="25%"
                            justify="center"
                            direction="column"
                            align="center"
                            bg="white"
                            borderRadius="30px"
                            position="relative"
                          >
                            <Flex
                              border="5px solid"
                              borderColor={borderColor}
                              bg="linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"
                              borderRadius="50%"
                              w="94px"
                              h="94px"
                              align="center"
                              justify="center"
                              mx="auto"
                              position="absolute"
                              left="50%"
                              top="-47px"
                              transform="translate(-50%, 0%)"
                            >
                              <Image src={main_logo} w="40px" h="40px" />
                            </Flex>
                            <Flex
                              direction="column"
                              mb="12px"
                              align="center"
                              justify="center"
                              px="15px"
                              pt="55px"
                            >
                              <Text
                                fontSize={{ base: "lg", xl: "18px" }}
                                color="black"
                                fontWeight="bold"
                                lineHeight="150%"
                                textAlign="center"
                                px="10px"
                                mt="10px"
                                mb="6px"
                              >
                                Chat with your database.
                              </Text>
                              <Text
                                fontSize="14px"
                                color={"black"}
                                fontWeight="500"
                                px="10px"
                                mb="6px"
                                textAlign="center"
                              >
                                Chat with your database.
                              </Text>
                            </Flex>
                            <Button
                              onClick={() => {
                                setTypeChat("database_chat");
                              }}
                              bg="gray.200"
                              _hover={{ bg: "#422AFB", color: "white" }}
                              _active={{ bg: "whiteAlpha.100" }}
                              mb={{ sm: "16px", xl: "24px" }}
                              color={"black"}
                              fontWeight="regular"
                              fontSize="sm"
                              minW="185px"
                              mx="auto"
                            >
                              Chat
                            </Button>
                          </Flex>
                        </>
                      )}
                    </Box>
                  )}
                </>
              </Box>
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
